import { NavLink } from 'react-router-dom';
import { useSync } from '../sync/useSync';

export default function BottomNav() {
  const { pending, rejected } = useSync();
  const count = pending + rejected;
  return (
    <nav className="bottomnav">
      <NavLink to="/scan" className={({ isActive }) => (isActive ? 'active' : '')}>
        <span className="ic">📟</span>Scan
      </NavLink>
      <NavLink to="/dashboard" className={({ isActive }) => (isActive ? 'active' : '')}>
        <span className="ic">📊</span>Dashboard
      </NavLink>
      <NavLink to="/daily" className={({ isActive }) => (isActive ? 'active' : '')}>
        <span className="ic">📖</span>Daily log
      </NavLink>
      <NavLink to="/complaints" className={({ isActive }) => (isActive ? 'active' : '')}>
        <span className="ic">🛠️</span>Complaints
      </NavLink>
      <NavLink to="/profile" className={({ isActive }) => (isActive ? 'active' : '')}>
        <span className="ic" style={{ position: 'relative' }}>
          👤{count > 0 && <span className={`badge${rejected > 0 ? ' bad' : ''}`}>{count}</span>}
        </span>
        Profile
      </NavLink>
    </nav>
  );
}
